/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { InputAction } from "../enums/InputAction";

/**
 * Translates raw MouseEvent / WheelEvent → abstract InputAction.
 */
export class PointerMapper {
  public resolveMouseEvent(event: MouseEvent): InputAction {
    switch (event.type) {
      case "click":
        return InputAction.POINTER_CLICK;
      case "contextmenu":
        return InputAction.POINTER_CONTEXT_MENU;
      case "mouseover":
        return InputAction.POINTER_HOVER;
      case "mouseout":
        return InputAction.POINTER_LEAVE;
      default:
        return InputAction.UNKNOWN;
    }
  }

  public resolveWheelEvent(event: WheelEvent): InputAction {
    if (event.deltaY < 0) {
      return InputAction.SCROLL_UP;
    }
    if (event.deltaY > 0) {
      return InputAction.SCROLL_DOWN;
    }
    return InputAction.UNKNOWN;
  }
}
